import { isPlatformBrowser } from '@angular/common';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';
import { catchAndLogError } from '@rma/generic/rxjs/operators/catch-and-log-error';
import { rmaShareReplay } from '@rma/generic/rxjs/operators/rma-share-replay';
import { from, map, Observable, of, take } from 'rxjs';
import { GOOGLE_MAPS_API_KEY } from './google-maps.provider';

@Injectable({ providedIn: 'root' })
export class GoogleMapsScriptService {
  private readonly apiKey = inject(GOOGLE_MAPS_API_KEY, { optional: true });
  private readonly isBrowser = isPlatformBrowser(inject(PLATFORM_ID));

  public appendScript(): Observable<boolean> {
    if (this.isBrowser) {
      const loader = new Loader({
        apiKey: this.apiKey ?? '',
        version: 'weekly',
        libraries: ['places', 'geometry', 'marker'],
      });

      return from(loader.importLibrary('maps')).pipe(
        map((googleMap) => !!googleMap),
        catchAndLogError<boolean>(of(false)),
        take(1),
        rmaShareReplay(),
      );
    }

    return of(false);
  }
}
